import { useEffect, useState } from 'react';
import { useStore } from 'zustand';

import { Button } from '@/components/ui/button/button.component';
import { useLoading } from '@/hooks/use-loading.hook';
import { forgotPassword } from '@/services/auth/login.service';
import { StepKeys } from '@/app/(main)/_components/sign-in-modal/_types/header-auth-modal-step-keys.enum';
import { loginDocumentNumberStore } from '@/store/login.store';
import { useProgressiveModal } from '@/components/ui/progressive-modal/progressive-modal.hook';
import { emailSac } from '@/utils/consts/sac.consts';
import { getLogger } from '@/logger/logger';

const phone = '+55 (41) 3003-5153';
const message = 'Oi, estava no Agendamento Online da Medprev e preciso de ajuda';

export const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const { isLoading, startLoading, stopLoading } = useLoading();
  const loginDocumentNumber = useStore(loginDocumentNumberStore, (state) => state.loginDocumentNumber);

  const { handleJump: jump } = useProgressiveModal<StepKeys>();

  const handleClientSupportClick = () => {
    const phoneNumber = phone.replace(/[^\d]/g, '');
    const encodedMessage = encodeURIComponent(message);
    window.open(`https://wa.me/${phoneNumber}/?text=${encodedMessage}`, '_blank', 'noopener,noreferrer');
  };

  useEffect(() => {
    const forgotPasswordFetch = async () => {
      startLoading();
      try {
        if (loginDocumentNumber) {
          const { email } = await forgotPassword(loginDocumentNumber);
          setEmail(email);
        }
        stopLoading();
      } catch (error) {
        const logger = getLogger('ForgotPasswordComponent');
        logger.error('Error in forgot password', { loginDocumentNumber }, error);
      }
    };
    forgotPasswordFetch();
  }, []);

  return isLoading
    ? (
        <div className="loading loading-lg"></div>
      )
    : (
        <div>
          <p className="text-gray-800">
            Enviamos um e-mail para
            {' '}
            <span className="font-semibold text-base">{email}</span>
            {' '}
            com instruções para criar uma
            nova senha.
          </p>
          <Button
            variant="default"
            color="primary"
            className="mt-6 mb-8 text-xl"
            onClick={() => {
              jump({ key: StepKeys.LOGIN, returning: true });
            }}
          >
            Entendi
          </Button>
          <p className="leading-6 text-gray-800">
            O seu endereço de e-mail foi alterado?
            <br />
            <br />
            {' '}
            Fale com o nosso
            {' '}
            <span className="text-green-500 cursor-pointer font-bold" onClick={handleClientSupportClick}>
              atendimento ao cliente
            </span>
            {' '}
            através do número (41) 3003-5153 para restaurar o acesso à sua conta.
            {' '}
            <br />
            <br />
            Se preferir envie uma mensagem de e-mail para
            {' '}
            <a href={emailSac} className="cursor-pointer no-underline text-green-500 font-bold">
              sac@medprevonline.com
            </a>
          </p>
        </div>
      );
};
